export const PAGE_SECTIONS_ID = [
  {
    id: "todays-section",
    path: "/",
  },
  {
    id: "account-page",
    path: "/profile",
  },
  {
    id: "details-page",
    path: "/details/",
  },
  {
    id: "cart-page",
    path: "/cart",
  },
  {
    id: "wishlist-page",
    path: "/wishlist",
  },
  {
    id: "login-page",
    path: "/login",
  },
  {
    id: "signup-page",
    path: "/signup",
  },
  {
    id: "about-page",
    path: "/about",
  },
  {
    id: "contact-page",
    path: "/contact",
  },
  {
    id: "faq-page",
    path: "/faq",
  },
  {
    id: "privacy policy-page",
    path: "/privacy policy",
  },
  {
    id: "terms of use-page",
    path: "/terms of use",
  },
  {
    id: "checkout-page",
    path: "/checkout",
  },
  {
    id: "favorite-page",
    path: "/favorites",
  },
  {
    id: "search-page",
    path: "/search",
  },
  {
    id: "details-section",
    path: "/details",
  },
  {
    id: "products-section",
    path: "/products",
  },
  {
    id: "order-page",
    path: "/order",
  },
  {
    id: "category-page",
    path: "/category",
  },
  {
    id: "notfound-page",
  },
];
